import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import AskForAuthentication_vue_vue_type_script_setup_true_lang_default from "./AskForAuthentication.vue.script.js";
/* empty css                                   */
//#region src/views/Chat/Messages/AskForAuthentication.vue
var AskForAuthentication_default = /*#__PURE__*/ _plugin_vue_export_helper_default(AskForAuthentication_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-19cedfcd"]]);
//#endregion
export { AskForAuthentication_default as default };

//# sourceMappingURL=AskForAuthentication.vue.js.map